import React from "react";

export default function H5(props) {
  return (
    <h1 className="text-lg font-medium text-secondary py-2 mb-3">
      {props.children}
    </h1>
  );
}
